import { getMovie } from './movie'

/**
 * Get Package rich data
 * @param item
 * @param router
 * @param baseUrl
 * @returns {{itemListElement: {item: {image: *, '@type': string, author: {'@type': string, name: string}[], description, inLanguage: {'@type': string, name: string}[], subtitleLanguage: {'@type': string, name: string}[], '@context': string, url: *, duration: string, actor: {'@type': string, name: string}[], name, genre, contentRating: string}, '@type': string, position}[], '@type': string, name: *, '@context': string}}
 */
function getPackage (item, router, baseUrl) {
  return {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    name: item.title,
    itemListElement: item.videos.map((video, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      item: getMovie(video, router, baseUrl)
    }))
  }
}

export {
  getPackage
}
